export default{
    document:[],
    preloader:false
    
}


// WEBPACK FOOTER //
// ./src/modules/invoice_detail/state.js